<template>
  <div class="shopsUp">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span @click="onTab('shopsUp')"
              style="font-size:20px;font-weight:bold;border-bottom: 2px solid #409EFF;padding-bottom: 6px;color:#409EFF">出售中商品</span>
        <span @click="onTab('shopsDown')"
              style="font-size:20px;font-weight:bold;margin-left:20px;padding-bottom: 6px;">下架中商品</span>
      </div>
      <div class="search-box">
        <p style="width:auto;margin-left:15px;font-size:16px;font-weight:bold">商品分类：</p>
        <el-select v-model="edi_type" ref='select5' clearable
                   placeholder="商品类型" @change="onUpData"
                   style="width:8vw;margin-left:1px">
          <el-option
              v-for="item in liType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="scan_name" @change="onUpData" clearable prefix-icon="el-icon-search"
                  placeholder="请输入商品名称" style="width:12vw;margin-left:10px"></el-input>
        <el-button @click="onTabAdd" type="primary" style="margin-left:auto;margin-right:10px">
          发布商品
        </el-button>
      </div>
      <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                show-overflow-tooltip :row-key="rowKey"
                @selection-change="rowCurrentChange" ref="refShopsTab"
                :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
        <el-table-column
            v-if="isShow"
            type="selection"
            fixed="left"
            :reserve-selection="true"
            :selectable="checkSelectable"
            width="60">
        </el-table-column>
        <el-table-column width="1px">
        </el-table-column>
        <div v-for="(d,item) in this.defHead">
          <el-table-column v-if="d.key==='商品名称'" :key=item :prop=d.val :label=d.key :width="d.w">
            <template slot-scope="scope">
              <div style="display: flex;align-items:center">
                <el-image :src="scope.row.imgUrl" style="max-width:107px;height:60px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <p style="margin-left:15px">{{ scope.row.name }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="d.key==='价格'" :key=item :prop=d.val :label=d.key :width="d.w">
            <template slot-scope="scope">
              <div v-html="scope.row.skuPrice.replace(/、/g, '<br>')"></div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="d.key==='总库存'" :key=item :prop=d.val :label=d.key :width="d.w">
            <template slot-scope="scope">
              <div v-html="scope.row.kuCun.replace(/、/g, '<br>')"></div>
            </template>
          </el-table-column>
          <el-table-column v-else-if="d.key==='总销售'" :key=item :prop=d.val :label=d.key :width="d.w">
            <template slot-scope="scope">
              <div v-html="scope.row.saled.replace(/、/g, '<br>')"></div>
            </template>
          </el-table-column>
          <el-table-column v-else :key=item :prop=d.val :label=d.key :width="d.w">
          </el-table-column>
        </div>
        <el-table-column
            label="操作"
            width="200">
          <template slot-scope="scope">
            <el-button @click="onChange(scope.row)" type="text" size="small" icon="el-icon-edit"
                       style="color:#72767b;font-size: 16px"/>
            <el-button @click="onCheck(scope.row)" type="text" size="small" icon="el-icon-view"
                       style="color:#72767b;font-size: 16px"/>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;align-items:center;height:50px">
        <el-checkbox v-if="isShow" v-model="edi_check" @change="toAllSelection">全选
        </el-checkbox>
        <div>
          <el-button @click="onState(state2)" style="margin-left:10px">下架</el-button>
          <el-button @click="onDel" type="danger">删除</el-button>
        </div>
        <el-pagination
            style="margin-left:auto;margin-right:10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10,20,30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name:'shopsUp',
  data() {
    return {
      page:1,
      pageSize:10,
      total:0,
      state1:1, /*1为上架*/
      state2:2, /*2为下架*/
      isShow:false,
      edi_check:false,
      scan_name:'',
      liRow:[],
      edi_type:"",
      liType:[],
      liShop:[],
      li_shop:[],
      pageType:1,
      pageSizeType:30,
      totalType:30,
      defHead:[
        {'key':"商品名称",'val':"name","w":"auto"},
        {'key':"商品分类",'val':"goodsType","w":"auto"},
        {'key':"关联空间",'val':"room","w":"auto"},
        {'key':"价格",'val':"skuPrice","w":"auto"},
        {'key':"总库存",'val':"kuCun","w":"auto"},
        {'key':"总销售",'val':"saled","w":"auto"}
      ]
    };
  },
  methods:{
    onTab(ym) {
      this.$router.push({ /*路由跳转传值*/
        path:`/home/${ym}`
      });
    },
    onTabAdd() {
      this.$router.push({ /*路由跳转传值*/
        path:`/home/shopsSon`,
        query:{
          key:'add'
        }
      });
    },
    onShow() {
      this.isShow = true;
    },
    onChange(row) {
      this.$router.push({ /*路由跳转传值*/
        path:`/home/shopsSon`,
        query:{
          key:'change',
          id:row['id']
        }
      });
    },
    onCheck(row) {
      this.$router.push({ /*路由跳转传值*/
        path:`/home/shopsInfo`,
        query:{key:row['id']}
      });
    },
    onState(state) {
      if (this.isShow) {
        let goodsIds = [];
        if (this.liRow.length > 0) {
          for (let i = 0; i < this.liRow.length; i++) {
            goodsIds.push(this.liRow[i]['id']);
          }
        } else {
          this.$message.error("请先勾选商品");
          return;
        }
        const params = {
          goodsIds:goodsIds,
          goodsStateId:state,
          includeSku:true,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.changeGoodsState,params,headers).then(res => {
          console.log("changeGoodsState",res.data.data);
          this.isShow = false;
          this.liRow = [];
          this.edi_check = false;
          this.$refs.refShopsTab.clearSelection();
          this.getGoodsList();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("修改商品状态失败");
          }
        });
      } else {
        this.isShow = true;
      }
    },
    onDel() {
      if (this.isShow) {
        console.log(this.liRow);
        let goodsIds = [];
        if (this.liRow.length > 0) {
          for (let i = 0; i < this.liRow.length; i++) {
            goodsIds.push(this.liRow[i]['id']);
          }
        } else {
          this.$message.error("请先勾选商品");
          return;
        }
        const params = {
          goodsIds:goodsIds,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delGoods,params,headers).then(res => {
          console.log("delGoods",res.data.data);
          if (this.total % this.pageSize === this.liRow.length && this.page !== 1) {
            this.page -= 1;
          }
          this.isShow = false;
          this.liRow = [];
          this.edi_check = false;
          this.$refs.refShopsTab.clearSelection();
          this.getGoodsList();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("删除商品失败");
          }
        });
      } else {
        this.isShow = true;
      }
    },
    rowKey(row) { /*返回对应唯一值防止选中乱跳*/
      return row.id;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    checkSelectable(row,index) { /*tab选择框禁用*/
      return true;
    },
    rowCurrentChange(val) { /*获取所有选中行*/
      this.liRow = val;
      if (this.liShop && this.liRow.length === this.liShop.length) {
        this.edi_check = true;
      } else {
        this.edi_check = false;
      }
      console.log(this.liRow);
    },
    toAllSelection() {
      this.$refs.refShopsTab.toggleAllSelection(); // 全选/取消全选方法
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGoodsList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getGoodsList();
    },
    onUpData() {
      this.page = 1;
      this.getGoodsList();
    },
    initShop() {
      let li_d = [];
      for (let i = 0; i < this.li_shop.length; i++) {
        let d = {
          id:this.li_shop[i]['id'],
          name:this.li_shop[i]['name'],
          mainUrl:this.li_shop[i]['mainUrl'],
          room:"",
          goodsType:"",
          goodsState:"",
          kuCun:0,
          saled:0,
          skuPrice:0,
          imgUrl:""
        };
        if (this.li_shop[i]['room']) {
          d["room"] = this.li_shop[i]['room']['name'];
        }
        if (this.li_shop[i]['iconBig']) {
          d['imgUrl'] = this.$urls.ip + "/" + this.li_shop[i]['iconBig']['url'];
        }
        if (this.li_shop[i]['goodsType']) {
          d['goodsType'] = this.li_shop[i]['goodsType']['name'];
        }
        if (this.li_shop[i]['goodsState']) {
          d['goodsState'] = this.li_shop[i]['goodsState']['name'];
        }
        let kuCun = "";
        let saled = "";
        let skuPrice = "";
        if (this.li_shop[i]['goodsSku'] && this.li_shop[i]['goodsSku'].length > 0) {
          for (let j = 0; j < this.li_shop[i]['goodsSku'].length; j++) {
            kuCun += `${this.li_shop[i]['goodsSku'][j]['skuName']}-${this.li_shop[i]['goodsSku'][j]['kuCun']}、`;
            saled += `${this.li_shop[i]['goodsSku'][j]['skuName']}-${this.li_shop[i]['goodsSku'][j]['saled']}、`;
            skuPrice += `${this.li_shop[i]['goodsSku'][j]['skuName']}-${this.li_shop[i]['goodsSku'][j]['skuPrice'][0]['price'] / 100}、`;
          }
        }
        d["saled"] = saled;
        d["kuCun"] = kuCun;
        d["skuPrice"] = skuPrice;
        li_d.push(d);
      }
      this.liShop = li_d;
    },
    getGoodsList() {
      const params = {
        page:this.page,
        pageSize:this.pageSize,
        goodsstateId:this.state1,
        projectId:localStorage.getItem("projectId")
      };
      if (this.scan_name.length > 0) {
        params['name'] = this.scan_name;
      }
      if (this.edi_type) {
        params['goodsTypeId'] = this.edi_type;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoodsList,params,headers).then(res => {
        console.log("getGoodsList",res.data.data);
        this.total = res.data.data.total;
        if (res.data.data.list) {
          this.li_shop = res.data.data.list;
          this.initShop();
        } else {
          this.liShop = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品数据失败");
        }
      });
    },
    getGoodsTypeList() {
      if (this.pageType < this.totalType / this.pageSizeType + 1) {
        const params = {
          page:this.pageType,
          pageSize:this.pageSizeType,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.getGoodsTypeList,params,headers).then(res => {
          console.log("getGoodsTypeList",res.data.data);
          this.totalType = res.data.data.total;
          if (res.data.data.list) {
            const l_d = this.liType;
            let l = res.data.data.list;
            for (let i = 0; i < l.length; i++) {
              l_d.push({label:l[i]['name'],value:l[i]['id']});
            }
            this.liType = l_d;
            this.pageType += 1;
            this.getGoodsTypeList();
          }
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("获取商品类型数据失败");
          }
        });
      }
    },
    getGoodsStateList() {
      const params = {
        page:1,
        pageSize:30,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getGoodsStateList,params,headers).then(res => {
        console.log("getGoodsStateList",res.data.data);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品状态数据失败");
        }
      });
    }
  },
  mounted() {
    this.getGoodsList();
    this.getGoodsStateList();
    this.getGoodsTypeList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.liShop.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style scoped>
.shopsUp {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
}

.search-box {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/shopsUp.vue